import { h } from "preact";

import { classNames, renderHtml, replaceRedactions } from "../helpers";
import Tag from "./Tag.jsx";
import { Link } from "react-router-dom";

export default function PartnerDetails({ partner }) {
  return (
    <Link
      to={`/marketplace/${encodeURIComponent(partner.id)}`}
      class="partner-page-item"
    >
      <div
        class={classNames(
          "partner-page-item__logo-image",
          partner.logoImage.square && "partner-page-item__logo-image--square"
        )}
        style={`background-color: ${partner.logoImage.backgroundColor}`}
      >
        <img src={partner.logoImage.url} alt={`Logo of ${partner.title}`} />
      </div>

      <div class="partner-page-item__logo-card">
        <h5 class="partner-page-item__company-name t-h6--margin-small">
          {partner.title}
        </h5>

        <div class="t-subtitle1 mb-16">{renderHtml(partner.body)}</div>

        <div class="markdown-body partner-page-item__benefits mb-16">
          {renderHtml(
            replaceRedactions(
              partner.benefits || partner.benefitsLoggedOut,
              true
            )
          )}
        </div>

        <div class="mt-16">
          {partner.tags.map((tag) => (
            <Tag noHover grey>
              {tag}
            </Tag>
          ))}
        </div>
      </div>
    </Link>
  );
}
